import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { SEPTEMBER_2025_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(SEPTEMBER_2025_CAMPAIGN_END_DATE);
